import { ReactNode, createContext, useContext, useState } from 'react'

import { Reservation } from '@monorepo/functions/src/types/reservations'

interface ReservationModalContextValue {
    reservationInModal: Reservation | null
    openReservationModal: (reservation: Reservation | null) => void
}

const ReservationModalContext = createContext<ReservationModalContextValue | undefined>(undefined)

export const ReservationModalProvider = ({ children }: { children: ReactNode }) => {
    const [reservationInModal, setReservationInModal] = useState<Reservation | null>(null)

    const openReservationModal = (reservation: Reservation | null) => {
        setReservationInModal(reservation)
    }

    return (
        <ReservationModalContext.Provider value={{ reservationInModal, openReservationModal }}>
            {children}
        </ReservationModalContext.Provider>
    )
}

export const useReservationModal = () => {
    const context = useContext(ReservationModalContext)
    if (!context) {
        throw new Error('useReservationModal must be used within a ReservationModalProvider')
    }
    return context
}
